<template>
  <div>
    <v-card class="my-1">
      <v-card-title>Attendance Report</v-card-title>
      <v-row class="px-4">
        <v-col class="py-0 pt-3">
          <v-autocomplete
            v-model="employee"
            v-validate="'required'"
            label="Employee"
            multiple
            clearable
            deletable-chips
            :error-messages="errors.collect('employee')"
            data-vv-name="employee"  
            data-vv-as="employee"
            chips
            dense
            :items="employees"
            item-text="person.name"
            item-value="employee_uid"
            small-chips
            hide-selected
          />
        </v-col>

        <v-col class="py-0">
          <v-menu
            v-model="startDateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="startDateDisplay"
                v-validate="'required'"
                label="Start Date"
                prepend-icon="mdi-calendar"
                :error-messages="errors.collect('startDateDisplay')"
                data-vv-name="startDateDisplay"  
                data-vv-as="start date"    
                readonly
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="startDate"
              @input="startDateMenu = false"
            />
          </v-menu>
        </v-col>

        <v-col class="py-0">
          <v-menu
            v-model="endDateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="endDateDisplay"
                v-validate="'required'"
                label="End Date"
                prepend-icon="mdi-calendar"
                :error-messages="errors.collect('endDateDisplay')"
                data-vv-name="endDateDisplay"  
                data-vv-as="end date"  
                readonly
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="endDate"
              @input="endDateMenu = false"
            />
          </v-menu>
        </v-col>
    
        <v-col>
          <v-row>
            <v-btn
              class="mx-3"
              color="primary"
              :loading="loading"
              @click="download"
            >
              generate
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    data () {
      return {
        startDateMenu: false,
        startDate: null,
        endDateMenu: false,
        endDate: null,
        loading: false,
        employee: [],
        employees: [],
      }
    },
    computed: {
      startDateDisplay () {
        return this.startDate ? this.$moment(this.startDate, 'YYYY-MM-DD').format('D MMM YYYY') : ''
      },
      endDateDisplay () {
        return this.endDate ? this.$moment(this.endDate, 'YYYY-MM-DD').format('D MMM YYYY') : ''
      },
    },
    created () {
      Promise.all([
        this.$api.hrisEmployees().list(),
      ])
        .then(([employees]) => {
          this.employees = _.orderBy(employees.data, ['person.name'], ['asc'])
        })
    },
    methods: {
      download () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.loading = true

            this.$api.attendanceReports().generateSubordinateAttendanceReport(this.prepareFormData())
              .then(res => {
                let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.setAttribute('download', 'Subordinate Attendance.xlsx') 
                link.click()
                this.loading = false
              }).catch((e) => {
                this.loading = false
              })
          })
      },

      prepareFormData () {
        return {
          employees: this.employee,
          startDate: this.startDate,
          endDate: this.endDate, 
        }
      },
    },
  }
</script>
